<template>
  <footer class="d-inline-block w-100 p-3 text-center mt-3">
    <div id="text" class="box-shadow p-2">
      <a
        href="http://www.logicielradar.com/"
        target="_blank"
        class="text-primary"
        ><u> {{ "components.footer.owner" | i18n }}</u></a
      >
      {{ "components.footer.rights" | i18n }}
    </div>
  </footer>
</template>
<script>
/**
 * @description Affiche le pied de page
 * @author Francine Jin
 * @author Alexandre Gallant
 * @vue-prop {Boolean} hideOnPhone - Si le pied de page doit être caché sur téléphone
 * @vue-prop {Boolean} background - Si le pied de page doit avoir une couleur de fond
 */
export default {
  name: "Footer",
  props: {
    hideOnPhone: {
      type: Boolean,
      required: false,
      default: false
    },
    background: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>

<style scoped>
footer {
  z-index: 1;
}
#text {
  font-size: 12px;
}
</style>
